// src/components/kuestion/student/assignmentShape.js
//
// One reader for a GET /campus/my/assignments row. The contract moved between
// v4 and the item 3 schema (frontend reply 3 §3.2, backend action note 17 Sep):
//
//   v4                                   item 3 schema
//   id                                   assignment_id
//   template_name                        title (template_name also on the row)
//   time_limit (minutes)                 time_limit_seconds
//   question_count                       total_questions
//   attempts, best_percentage (row)      inside the status block
//   status: "in_progress" + session_id   status: { state, sitting_id,
//     answered_count, seconds_remaining             answered_count, seconds_remaining }
//
// Screens read the normalised row only, so the day the server ships there is
// nothing to change in them.
export const DONE_STATES = new Set(['submitted', 'expired']);

export function normaliseAssignment(a) {
  if (!a || typeof a !== 'object') return a;
  const block = a.status && typeof a.status === 'object' ? a.status : null;
  const state = block ? block.state : a.status;
  const pick = (k) => (block && block[k] != null ? block[k] : a[k]);
  const limitSeconds = a.time_limit_seconds != null ? Number(a.time_limit_seconds)
    : (a.time_limit != null ? Number(a.time_limit) * 60 : null);
  const available = a.seconds_available_if_started_now != null ? Number(a.seconds_available_if_started_now) : null;
  return {
    ...a,
    id: a.id ?? a.assignment_id,
    template_name: a.title || a.template_name,
    status: state || (a.submitted || a.completed ? 'submitted' : 'not_started'),
    sitting_id: pick('sitting_id'),
    session_id: pick('session_id'),
    answered_count: pick('answered_count'),
    seconds_remaining: pick('seconds_remaining'),
    // self_assessment only (schema v2 §6.2)
    attempts: pick('attempts'),
    best_percentage: pick('best_percentage'),
    question_count: a.total_questions ?? a.question_count,
    time_limit_seconds: limitSeconds,
    time_limit: limitSeconds != null ? Math.round(limitSeconds / 60) : a.time_limit,
    seconds_available: available,
    // The window closes before the paper's own time would run out. Computed by
    // the server, accommodations included; the client's clock is never used.
    short_window: available != null && limitSeconds != null && limitSeconds > 0 && available < limitSeconds,
  };
}

export const normaliseAssignments = (d) => (Array.isArray(d) ? d : (d?.assignments || [])).map(normaliseAssignment);

export const isDone = (a) => DONE_STATES.has(a?.status);

// "5 minutes", "1 hour 10 minutes", "40 seconds"
export function spokenDuration(seconds) {
  const s = Math.max(0, Math.floor(Number(seconds) || 0));
  if (s < 60) return `${s} second${s === 1 ? '' : 's'}`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m} minute${m === 1 ? '' : 's'}`;
  const h = Math.floor(m / 60); const r = m % 60;
  return `${h} hour${h === 1 ? '' : 's'}${r ? ` ${r} minute${r === 1 ? '' : 's'}` : ''}`;
}
